import { useAuth, useEventMemberships } from '@shared/components/AuthProvider';
import { useAddItemToRegistryAttempt } from './useAddItemToRegistryAttempt';
import { useAutoAssociateUserToEvent } from './useAutoAssociateUserToEvent';
import { useEventAssociator } from './useEventAssociator';
import { useEventIdFromContext } from './useEventIdFromContext';
import { usePublicShopRootQuery } from '@graphql/generated';

export const useShopController = () => {
  const { currentUser, hasInitializedOnce } = useAuth();
  const { eventMemberships, loading: isLoadingEventMemberships } = useEventMemberships();
  const { addToRegistryAttemptInfo, trackAttempt, resetAttempt } = useAddItemToRegistryAttempt();

  const initialEventId = useEventIdFromContext();

  const { eventId, showEventPickerDialog, onSingleMatch, onZeroOrMultipleMatches } = useEventAssociator({ addToRegistryAttemptInfo });

  const { data, loading: isLoadingEventData } = usePublicShopRootQuery({ variables: { eventId: eventId || '', includeEvent: !!eventId }, batchMode: 'fast' });

  useAutoAssociateUserToEvent({
    eventId,
    eventMemberships,
    hasAuthenticatedOnce: hasInitializedOnce && !isLoadingEventMemberships,
    initialEventId,
    onSingleMatch,
    onZeroOrMultipleMatches,
  });

  return {
    currentUser,
    eventId: isLoadingEventData ? undefined : eventId,
    eventType: data?.eventById?.info?.eventType || null,
    handleOnAddItemToRegistryWithoutEvent: trackAttempt,
    addToRegistryAttemptInfo,
    removeAddAttemptInfo: resetAttempt,
    showEventPickerDialog,
    shippingAddress: data?.eventById?.registry.shippingAddress || null,
    registryCurrency: data?.eventById?.registry.currency || null,
    finalizedDate: data?.eventById?.info?.finalizedDate || null,
    registries: data?.eventById?.info?.registry || null,
    orders: data?.eventById?.registry?.orders,
    website: data?.eventById?.website || null,
    finalizedEventDate: data?.eventById?.info?.finalizedDate,
  } as const;
};
